module.exports = __webpack_public_path__ + "img/img1.6e33d8f9.png";